// import React, { useState, useEffect } from "react";
// import { Card, Row, Col, Typography, Divider, Space, Button, List, Spin, Modal } from "antd";
// import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
// import "../../../assets/dist/ConsumerProject/Consumer/ConsumerPreview.css"
// import "./ConsumerUploadDocumentsPreview.css";
// import _consumerService from "../../../modules/consumerService";
// import _commonService from "../../../modules/commonService";
// import { ExclamationCircleOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
// import { useHistory, useLocation } from "react-router-dom";
// import { routes } from "../../../routes/Routes";
// import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
// import ConsumerApplicationProgressBar from "../Consumer/ConsumerApplicationProgressBar";
// import ConsumerShowApplicationId from "../Consumer/ConsumerShowApplicationId";
// import LoanApplicationStepper from "../../../components/LoanApplicationStepper";
// import ApplicationHeader from "../../../components/ApplicationHeader";
// import LoanApplicationFooter from "../../../components/LoanApplicationFooter";

// const { Text, Title } = Typography;
// const { confirm } = Modal;

// const ConsumerUploadDocumentsPreview = () => {
//     const history = useHistory();
//     const [applicantDetails, setApplicantDetails] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [isModalVisible, setIsModalVisible] = useState(false);
//     const [selectedDocUrl, setSelectedDocUrl] = useState('');
//     const [selectedDocName, setSelectedDocName] = useState('');
//     const [fromNewAppPage] = useState(JSON.parse(localStorage.getItem("fromNewApplicationPage")));
//     const [isFromMyAppListPage] = useState(JSON.parse(localStorage.getItem("isFromMyApplicationsList")));

//     const location = useLocation();
//     let locData = location.state;

//     useEffect(() => {
//         if (!locData || (typeof locData === "object" && Object.keys(locData).length === 0)) {
//             history.push({ pathname: routes.consumerDashboard.path });
//             return;
//         }
//         getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
//     }, []);

//     const getApplicantDetailsByID = async (applicationObjId) => {
//         setLoading(true);
//         try {
//             const res = await _consumerService.getConsumerInformationByConsumerId(applicationObjId);
//             if (res.data) {
//                 let resObj = res?.data;
//                 setApplicantDetails(resObj);
//                 setLoading(false);
//             }
//         } catch (e) {
//             console.log(e);
//             setLoading(false);
//         }
//     };

//     const onDocumentEyeClick = (item) => {
//         setSelectedDocName(item.name);
//         setSelectedDocUrl(item.url);
//         setIsModalVisible(true);
//     };

//     const onDocumentDownloadClick = (item) => {

//         if (item === "Personal Financial Statement") {
//             if (applicantDetails?.Cons_PFS) {
//                 setLoading(true);
//                 //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Personal_FinStatement_Path;
//                 const fileUrl = applicantDetails.Cons_PFS;
//                 const fileName = applicantDetails.Cons_PFS.split("/").pop();

//                 const link = document.createElement("a");
//                 link.href = fileUrl;
//                 link.setAttribute("download", fileName);
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//                 setLoading(false);
//             }
//         } else if (item === "First 2 Pages of Federal Tax Return") {
//             if (applicantDetails?.Cons_FederalTax) {
//                 setLoading(true);
//                 //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path;
//                 const fileUrl = applicantDetails.Cons_FederalTax;
//                 const fileName = applicantDetails.Cons_FederalTax.split("/").pop();

//                 const link = document.createElement("a");
//                 link.href = fileUrl;
//                 link.setAttribute("download", fileName);
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//                 setLoading(false);
//             }
//         } else if (item == "K-1s") {
//             if (applicantDetails?.Cons_K1s) {
//                 setLoading(true);
//                 //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2;
//                 const fileUrl = applicantDetails.Cons_K1s;
//                 const fileName = applicantDetails.Cons_K1s.split("/").pop();

//                 const link = document.createElement("a");
//                 link.href = fileUrl;
//                 link.setAttribute("download", fileName);
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//                 setLoading(false);
//             }
//         } else if (item === "Fund Statements or Private Stock Evidence") {
//             if (applicantDetails?.Cons_FundStatement) {
//                 setLoading(true);
//                 //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Credit_Breau_Report_Path;
//                 const fileUrl = applicantDetails.Cons_FundStatement;
//                 const fileName = applicantDetails.Cons_FundStatement.split("/").pop();

//                 const link = document.createElement("a");
//                 link.href = fileUrl;
//                 link.setAttribute("download", fileName);
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//                 setLoading(false);
//             }
//         } else if (item == "Credit Bureau Report") {
//             if (applicantDetails?.Cons_CreditReport) {
//                 setLoading(true);
//                 //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc3_Credit_Bureau_Report_CBR;
//                 const fileUrl = applicantDetails.Cons_CreditReport;
//                 const fileName = applicantDetails.Cons_CreditReport.split("/").pop();

//                 const link = document.createElement("a");
//                 link.href = fileUrl;
//                 link.setAttribute("download", fileName);
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//                 setLoading(false);
//             }
//         } else {
//             console.error("Unknown document type:", item);
//         }
//     };

//     // const deleteDocument = (item) => {
//     //     confirm({
//     //         title: `Are you sure, want to delete this ${item.name}?`,
//     //         icon: <ExclamationCircleOutlined />,
//     //         okText: <span id="yesBtn">Yes</span>,
//     //         cancelText: <span id="noBtn">No</span>,
//     //         okType: "primary",
//     //         onOk() {
//     //             deleteDocumentObj(item.name);
//     //         }
//     //     });
//     // };

//     // const deleteDocumentObj = async (item) => {
//     //     console.log("item", item);
//     //     setLoading(true);
//     //     let documentType = "";
//     //     if (item === "Personal Financial Statement") {
//     //         documentType = "levconspfs";
//     //     } else if (item === "First 2 Pages of Federal Tax Return") {
//     //         documentType = "levconsfederaltax";
//     //     } else if (item === "K-1s") {
//     //         documentType = "levconsk1s";
//     //     } else if (item === "Fund Statements or Private Stock Evidence") {
//     //         documentType = "levconsfundstatement";
//     //     } else if (item === "Credit Bureau Report") {
//     //         documentType = "levconscreditreport";
//     //     } else {
//     //         console.error("Unknown document type:", item);
//     //     }

//     //     try {
//     //         const res = await _consumerService.deleteDocumentDataByApplicationId(localStorage.getItem("ApplicationObjId"), documentType);
//     //         if (res.data.IsSuccess) {
//     //             setLoading(false);
//     //             message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
//     //             getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
//     //         } else {
//     //             setLoading(false);
//     //             message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
//     //         }
//     //     } catch (e) {
//     //         setLoading(false);
//     //         console.log(e);
//     //     }
//     // };

//     const documentMap = {
//         "Personal Financial Statement": applicantDetails?.Cons_PFS,
//         "First 2 Pages of Federal Tax Return": applicantDetails?.Cons_FederalTax,
//         "K-1s": applicantDetails?.Cons_K1s,
//         "Fund Statements or Private Stock Evidence": applicantDetails?.Cons_FundStatement,
//         "Credit Bureau Report": applicantDetails?.Cons_CreditReport,
//     };

//     const documents = Object.entries(documentMap)
//         .filter(([_, path]) => !!path)
//         .map(([name, path]) => ({ name, url: path }));

//     const onBack = () => {
//         if (fromNewAppPage || isFromMyAppListPage) {
//             history.push({ pathname: routes.documentsUpload.path, state: { isFromDashboard: false } });
//         } else {
//             history.push(routes.consumerDetailsDashboard.path);
//         }
//     };

//     const onSaveNext = () => {
//         confirm({
//             title: `Once you upload, our platform will complete a preliminary financial assessment. Please review all inputs for accuracy prior to submitting.`,
//             icon: <ExclamationCircleOutlined />,
//             okText: <span id="yesBtn">Upload Application</span>,
//             cancelText: <span id="noBtn">No</span>,
//             okType: "primary",
//             width: 600,
//             onOk() {
//                 history.push(routes.consumerDetailsDashboard.path);
//                 localStorage.setItem("fromNewApplicationPage", false);
//                 localStorage.setItem("isFromMyApplicationsList", false);
//             }
//         });
//     };

//     return (
//         <Spin spinning={loading}>
//             <SidebarLayoutConsumer>
//                 <div className="loan-application-container">
//                     {/* Responsive Stepper */}
//                     <LoanApplicationStepper currentStep={2} showApplicationId={true} />

//                     {/* Card */}
//                     <Card
//                         className="loan-application-card"
//                         bodyStyle={{ 
//                             display: "flex", 
//                             flexDirection: "column",
//                             flex: 1,
//                             overflow: "hidden",
//                             padding: "24px"
//                         }}
//                     >
//                         {/* Application Header */}
//                         {/* <ApplicationHeader
//                             currentStep={3}
//                             stepTitle="Preview Documents"
//                             showProgress={false}
//                             progressPercent={0}
//                             showApplicationId={true}
//                         />

//                         <Divider className="loan-application-divider" /> */}

//                         {/* Scrollable Content */}
//                         <div className="loan-application-scrollable-content loan-application-scrollbar">
//                             {documents && documents.length > 0 &&
//                                 <Card style={{ borderRadius: 12, fontSize: 14, border: 'none' }}>

//                                             <div style={{ rowGap: "10px" }}>
//                                                 <List
//                                                  className="documentPreview"
//                                                     dataSource={documents}
//                                                     renderItem={(item, index) => (
//                                                         <List.Item
//                                                             style={{
//                                                                 padding: "12px 5px",
//                                                                 // backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
//                                                                 borderBottom: index === documents.length - 1 ? "none" : "1px solid #2e2f30",
//                                                             }}
//                                                             actions={[
//                                                                 // <Button icon={<EyeOutlined />} type="text" key="view" onClick={() => onDocumentEyeClick(item)} />,
//                                                                 <Button className="iconColor" icon={<DownloadOutlined />} type="text" key="download" onClick={() => onDocumentDownloadClick(item.name)} />,
//                                                                 // <Button
//                                                                 //     // disabled={["1", "5"].includes(localStorage.getItem("ApplicationStatusId")) ? false : true}
//                                                                 //     icon={<DeleteOutlined />}
//                                                                 //     type="text" danger key="delete" onClick={() => deleteDocument(item)}
//                                                                 // />,
//                                                             ]}
//                                                         >
//                                                             <Space size="middle">
//                                                                 <Text strong style={{ width: 24 }}>{`0${index + 1}.`}</Text>
//                                                                 <Text>{item.name}</Text>

//                                                             </Space>
//                                                         </List.Item>
//                                                     )}
//                                                 />
//                                                 <Divider />
//                                                 <Row gutter={[24, 24]}>
//                                                     <Col xs={24} md={8}>
//                                                         <Text type="secondary">Requested Loan Amount:</Text> <br />
//                                                         <Text className="b-bottm">{applicantDetails?.App_Det_LoanAmount ? `$ ${applicantDetails.App_Det_LoanAmount}` : "N/A"}</Text>
//                                                     </Col>

//                                                     <Col xs={24} md={8}>
//                                                         <Text type="secondary">CBR Score:</Text> <br />
//                                                         <Text className="b-bottm">{applicantDetails && applicantDetails.CBRScore || "N/A"}</Text>
//                                                     </Col>


//                                                     {applicantDetails && applicantDetails.CalTDSRAmount &&
//                                                         <Col xs={24} md={8}>
//                                                             <Text type="secondary">TDSR:</Text> <br />
//                                                             <Text className="b-bottm">{applicantDetails && applicantDetails.CalTDSRAmount ?
//                                                                 applicantDetails && applicantDetails.CalTDSRAmount + " %" : "N/A"}</Text>
//                                                         </Col>
//                                                     }

//                                                     {applicantDetails && applicantDetails.CalLevridge &&
//                                                         <Col xs={24} md={8}>
//                                                             <Text type="secondary">Leverage:</Text> <br />
//                                                             <Text className="b-bottm">{applicantDetails && applicantDetails.CalLevridge || "N/A"}</Text>
//                                                         </Col>
//                                                     }

//                                                     {applicantDetails && applicantDetails.CalNetworthTotal &&
//                                                         < Col xs={24} md={8}>
//                                                             <Text type="secondary">Net Worth:</Text> <br />
//                                                             <Text className="b-bottm">{applicantDetails?.CalNetworthTotal ? `$ ${applicantDetails.CalNetworthTotal}` : "N/A"}</Text>
//                                                         </Col>
//                                                     }

//                                                     {applicantDetails && applicantDetails.CalDebtIncomeRatio &&
//                                                         <Col xs={24} md={8}>
//                                                             <Text type="secondary">Debt-to-Income Ratio:</Text> <br />
//                                                             <Text className="b-bottm">{applicantDetails && applicantDetails.CalDebtIncomeRatio ?
//                                                                 applicantDetails && applicantDetails.CalDebtIncomeRatio + " %" : "N/A"}</Text>
//                                                         </Col>
//                                                     }
//                                                 </Row>
//                                             </div>
//                                         </Card>

//                                     }
//                         </div>

//                         <LoanApplicationFooter
//                             onBack={onBack}
//                             submitDisabled={fromNewAppPage ? false : ![1, 6].includes(Number(localStorage.getItem("ApplicationStatusId")))}
//                             onSaveNext={onSaveNext}
//                         />

//                         <Modal
//                             open={isModalVisible}
//                             title={selectedDocName}
//                             onCancel={() => setIsModalVisible(false)}
//                             footer={null}
//                             width="70vw"
//                             bodyStyle={{ height: '70vh', padding: 0 }}
//                             destroyOnClose
//                         >
//                             <iframe
//                                 src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
//                                 width="100%"
//                                 height="100%"
//                                 style={{ border: "none" }}
//                                 title={selectedDocName}
//                             />
//                         </Modal>
//                     </Card>
//                 </div>
//             </SidebarLayoutConsumer>
//         </Spin>
//     )
// }
// export default ConsumerUploadDocumentsPreview;




import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography, Button, List, Spin, Modal } from "antd";
import { DownloadOutlined, FileExcelOutlined, ExclamationCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import LoanApplicationStepper from "../../../components/LoanApplicationStepper";
import LoanApplicationFooter from "../../../components/LoanApplicationFooter";
import _consumerService from "../../../modules/consumerService";
import { routes } from "../../../routes/Routes";

import "./ConsumerUploadDocumentsPreview.css";
import _commonService from "../../../modules/commonService";

const { Text, Title } = Typography;
const { confirm } = Modal;

const ConsumerUploadDocumentsPreview = () => {
    const history = useHistory();
    const location = useLocation();
    const [Documents, setDocuments] = useState([]);
    const [applicantDetails, setApplicantDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedDocUrl, setSelectedDocUrl] = useState("");
    const [selectedDocName, setSelectedDocName] = useState("");
    const [selectedDocType, setSelectedDocType] = useState("");
    let selectedApplicationFlow = null;
    const fromNewAppPage = JSON.parse(
        localStorage.getItem("fromNewApplicationPage")
    );
    const isFromMyAppListPage = JSON.parse(
        localStorage.getItem("isFromMyApplicationsList")
    );

    const locData = location.state;
     if (locData && locData.selectedDocumentOption) {
        selectedApplicationFlow = locData.selectedDocumentOption;
    }
    const [selectedApplicationDocFlow] = useState(selectedApplicationFlow);

    useEffect(() => {
        if (!locData) {
            history.push(routes.consumerDashboard.path);
            return;
        }
        getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
    }, []);

    useEffect(() => {
        if (localStorage.getItem("ApplicationObjId")) {
            getConsumerReportByConsumerId(localStorage.getItem("ApplicationObjId"));
        }
    }, [localStorage.getItem("ApplicationObjId")]);

    const getConsumerReportByConsumerId = async () => {
        try {
            setLoading(true);
            const res = await _consumerService.getConsumerReportByConsumerId(localStorage.getItem("ApplicationObjId"));

            const list = res?.data?.listApplicantDocs || [];

            setDocuments(
                list
                    .map((doc, index) => ({
                        id: index + 1,
                        name: doc.DocName,
                        url: doc.DocPath,
                        type: doc.DocType?.replace(".", "").toUpperCase(), // PDF / XLSX
                        size: doc.DocSize,
                        uploadedOn: doc.DocCreatedDate,
                    }))
                    .filter(doc => doc.type === "PDF" || doc.type === "XLSX")
            );
        } catch (error) {
            console.error("Failed to load reports", error);
        } finally {
            setLoading(false);
        }
    };

    const getApplicantDetailsByID = async (id) => {
        setLoading(true);
        try {
            const res =
                await _consumerService.getConsumerInformationByConsumerId(id);
            if (res?.data) setApplicantDetails(res.data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };


    const onView = (doc) => {
        setSelectedDocName(doc.name);
        setSelectedDocUrl(doc.url);
        setSelectedDocType(doc.type);
        setIsModalVisible(true);
    };



    const onDownload = (doc) => {
        const link = document.createElement("a");
        link.href = doc.url;
        link.download = doc.url.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    /* ---------- NAV ---------- */

    const onBack = () => {
        if (fromNewAppPage || isFromMyAppListPage) {
            history.push({ pathname: routes.documentsUpload.path, state: { isFromDashboard: false } });
        } else {
            history.push(routes.consumerDetailsDashboard.path);
        }
    };

    const onSaveNext = () => {
        if (selectedApplicationDocFlow == "manualentry") {
            localStorage.setItem("selectedDocumentOption", selectedApplicationDocFlow);
            history.push({ pathname: routes.incomeSourcesForConsumer.path, state: { selectedDocumentOption: selectedApplicationDocFlow, applicationObjId: localStorage.getItem("ConsumerUserId") } });
            localStorage.setItem("IsQuestionairCompleted", false);
        } else {
            confirm({
                title:
                    "Once you upload, our platform will complete a preliminary financial assessment. Please review all inputs carefully.",
                icon: <ExclamationCircleOutlined />,
                okText: "Upload Application",
                cancelText: "Cancel",
                width: 600,
                onOk() {
                    history.push(routes.consumerDetailsDashboard.path);
                    localStorage.setItem("IsQuestionairCompleted", false);
                }
            });
        }
    };



    /* ---------- Helper ---------- */
    const formatCurrency = (value) =>
        `$${Number(value || 0).toLocaleString()}`;

    const formatPercentage = (value) =>
        `${Number(value || 0).toFixed(2)}%`;


    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>

                <LoanApplicationStepper currentStep={2} showApplicationId />
                <div className="preview-root-wrapper">
                    <div className="preview-container">



                        <Card className="preview-card">
                            <div className="preview-inner">

                                {/* ===== Uploaded Documents ===== */}
                                <Title level={1} className="preview-header-title">
                                    Uploaded Documents
                                </Title>

                                <div className="section-container">
                                    <div className="preview-doc-list">
                                        <Text className="preview-subtitle">Document List</Text>
                                        <List
                                            dataSource={Documents}
                                            renderItem={(item) => (
                                                <List.Item
                                                    className="preview-doc-row"
                                                    actions={[
                                                        <Button
                                                            type="link"
                                                            className="view-btn"
                                                            onClick={() => onView(item)}
                                                        >
                                                            View
                                                        </Button>,
                                                        <Button
                                                            type="button"
                                                            icon={<DownloadOutlined />}
                                                            className="delete-btn"
                                                            onClick={() => onDownload(item)}
                                                        />
                                                    ]}
                                                >

                                                    <div className="doc-item-content">
                                                        <div className="doc-icon-box">
                                                            <FileExcelOutlined />
                                                        </div>

                                                        <div className="doc-text-info">
                                                            <Text className="priviewdocname">{item.name}</Text>
                                                            <Text type="secondary" className="priview-doc-meta">
                                                               {/* {item.size} • <span>Uploaded</span> {item.uploadedOn}                                                                                                                              {item.size} • <span>Uploaded</span> {item.uploadedOn} */}
                                                               <span>Uploaded</span> {item.uploadedOn}

                                                            </Text>
                                                        </div>
                                                    </div>


                                                </List.Item>
                                            )}
                                        />


                                    </div>
                                </div>

                                {/* ===== Metrics ===== */}


                                <Card className="section-card">
                                    <div>
                                        <Text className="preview-subtitle">Loan Summary Metrics</Text>

                                        <Row gutter={[24, 12]}>
                                            <Metric
                                                label="Requested Loan Amount"
                                                value={
                                                    applicantDetails?.App_Det_LoanAmount
                                                        ? `$ ${_commonService.formatNumberWithCommas(applicantDetails.App_Det_LoanAmount)}`
                                                        : "N/A"
                                                }
                                            />
                                            <Metric label="CBR Score" value={applicantDetails && applicantDetails.CBRScore || "N/A"} />
                                            <Metric
                                                label="Net Worth"
                                                value={
                                                    applicantDetails?.CalNetworthTotal
                                                        ? `$ ${_commonService.formatNumberWithCommas(applicantDetails.CalNetworthTotal)}`
                                                        : "N/A"
                                                }
                                            />
                                            <Metric label="Leverage" value={applicantDetails && applicantDetails.CalLevridge || "N/A"} />
                                            <Metric label="TDSR (Total Debt Servicing Ratio)" value={applicantDetails && applicantDetails.CalTDSRAmount ? applicantDetails && applicantDetails.CalTDSRAmount + " %" : "N/A"} />
                                            <Metric label="Debt-to-Income Ratio" value={applicantDetails && applicantDetails.CalDebtIncomeRatio ? applicantDetails && applicantDetails.CalDebtIncomeRatio + " %" : "N/A"} />
                                        </Row>
                                    </div>
                                </Card>

                                <div className="preview-note-container">
                                    <Text className="preview-note">
                                        <span className="note-bold">Note:  </span>
                                        These metrics are calculated based on your uploaded documents.Please review carefully before
                                        submitting your application.
                                    </Text>
                                </div>

                                <div className="loan-footer-wrapper">
                                    <LoanApplicationFooter
                                        onBack={onBack}
                                        submitDisabled={false}
                                        onSaveNext={onSaveNext}
                                    />
                                </div>

                            </div>
                        </Card>



                    </div>
                </div>

                {/* ===== Document Viewer ===== */}
                <Modal
                    visible={isModalVisible}   // 👈 FIXED
                    title={selectedDocName}
                    footer={null}
                    onCancel={() => setIsModalVisible(false)}
                    width="70vw"
                    destroyOnClose
                >
                    {selectedDocType === "PDF" && (
                        <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(
                                selectedDocUrl
                            )}&embedded=true`}
                            style={{ width: "100%", height: "70vh", border: "none" }}
                            title="pdf"
                        />
                    )}

                    {selectedDocType === "XLSX" && (
                        <iframe
                            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                                selectedDocUrl
                            )}&footer=false`}
                            style={{ width: "100%", height: "70vh", border: "none" }}
                            title="excel"
                        />
                    )}
                </Modal>


            </SidebarLayoutConsumer>
        </Spin>
    );
};

const Metric = ({ label, value }) => (
    <Col xs={24} sm={12} md={12}>
        <div className="metric-card">
            <Text className="metric-label">{label}</Text>
            <Text className="metric-value">{value}</Text>
        </div>
    </Col>
);

export default ConsumerUploadDocumentsPreview;
